<template>
  <div>
    <b-container fluid>
      <h1>設計済コマンド</h1>
      <b-tabs fill>
        <b-tab title="コマンド設計">
          <button
            class="btn btn-outline-secondary"
            @click="displayCommand"
          >表示</button>
          <button
            class="btn btn-outline-secondary"
            @click="downloadCommandCSV"
          >DL</button>
          <b-row>
            <b-pagination
              v-model="commandCurrentPage"
              :total-rows="commandTotalRows"
              :per-page="commandPerPage"
              align="fill"
              size="sm"
              aria-controls="command-design-table"
            ></b-pagination>
          </b-row>
          <b-table
            id="command-design-table"
            :fields="commandFields"
            :items="commandItems"
            :current-page="commandCurrentPage"
            :per-page="commandPerPage"
            responsive
            small
            bordered
          >
            <template v-slot:cell(no)="data">
              <div>
                {{ (commandCurrentPage - 1)* commandPerPage + data.index + 1 }}
              </div>
            </template>
          </b-table>
        </b-tab>
        <b-tab title="通信別コマンド設計">
          <button
            class="btn btn-outline-secondary"
            @click="displayByProtocol"
          >表示</button>
          <button
            class="btn btn-outline-secondary"
            @click="downloadByProtocolCSV"
          >DL</button>
          <b-row>
            <b-col cols="2">
              <b-form-select
                v-model="byProtocolFilterItem"
                :options="byProtocolFilterOptions"
              ></b-form-select>
            </b-col>
            <b-col cols="4">
              <b-form-input
                v-model="byProtocolFilterString"
              ></b-form-input>
            </b-col>
          </b-row>
          <b-row>
            <b-pagination
              no-sort-reset
              v-model="byProtocolCurrentPage"
              :total-rows="byProtocolTotalRows"
              :per-page="byProtocolPerPage"
              align="fill"
              size="sm"
              aria-controls="by-protocol-design-table"
            ></b-pagination>
          </b-row>
          <b-table
            id="by-protocol-design-table"
            :fields="byProtocolFields"
            :items="byProtocolItems"
            :current-page="byProtocolCurrentPage"
            :per-page="byProtocolPerPage"
            :filterIncludedFields="[byProtocolFilterItem]"
            :filter="byProtocolFilterRegexp"
            class="table-responsive"
            bordered
          >
            <template v-slot:cell(no)="data">
              <div>
                {{ (byProtocolCurrentPage - 1)* byProtocolPerPage + data.index + 1 }}
              </div>
            </template>
          </b-table>
        </b-tab>
        <b-tab title="機種別コマンド設計">
          <button
            class="btn btn-outline-secondary"
            @click="displayBySender"
          >表示</button>
          <button
            class="btn btn-outline-secondary"
            @click="downloadBySenderCSV"
          >DL</button>
          <b-row>
            <b-col cols="2">
              <b-form-select
                v-model="bySenderFilterItem"
                :options="bySenderFilterOptions"
              ></b-form-select>
            </b-col>
            <b-col cols="4">
              <b-form-input
                v-model="bySenderFilterString"
              ></b-form-input>
            </b-col>
          </b-row>
          <b-row>
            <b-pagination
              v-model="bySenderCurrentPage"
              :total-rows="bySenderTotalRows"
              :per-page="bySenderPerPage"
              align="fill"
              size="sm"
              aria-controls="by-protocol-design-table"
            ></b-pagination>
          </b-row>
          <b-table
            :fields="bySenderFields"
            :items="bySenderItems"
            :current-page="bySenderCurrentPage"
            :per-page="bySenderPerPage"
            :filterIncludedFields="[bySenderFilterItem]"
            :filter="bySenderFilterString"
            class="table-responsive"
            bordered
          >
            <template v-slot:cell(no)="data">
              <div>
                {{ (bySenderCurrentPage - 1)* bySenderPerPage + data.index + 1 }}
              </div>
            </template>
          </b-table>
        </b-tab>
      </b-tabs>
    </b-container>
  </div>
</template>
<script>
import { API, graphqlOperation } from 'aws-amplify'
import { mapState } from 'vuex'
export default {
  name: 'CommandList',
  data () {
    return {
      displayCommandTable: false,
      commandCurrentPage: 1,
      commandPerPage: 100,
      commandFields: [
        { key: 'no', label: 'No.', sortable: true, sortDirection: 'ASC' },
        { key: 'function_class', label: 'システム機能分類', sortable: true },
        { key: 'record_name', label: '属性/プロパティ名称', sortable: true },
        { key: 'communication_trigger', label: '通信トリガ', sortable: true },
        { key: 'frame_type', label: 'フレーム種別', sortable: true },
        { key: 'design_sender', label: '設計用送信元', sortable: true },
        { key: 'design_destination', label: '設計用送信先', sortable: true },
        { key: 'sa', label: 'SA', sortable: true },
        { key: 'da', label: 'DA', sortable: true },
        { key: 'sr', label: 'SR', sortable: true },
        { key: 'dr', label: 'DR', sortable: true },
        { key: 'common_sender', label: '共通送信元', sortable: true },
        { key: 'common_destination', label: '共通送信先', sortable: true },
        { key: 'integration_sender', label: '統合送信元', sortable: true },
        { key: 'integration_destination', label: '統合送信先', sortable: true },
        { key: 'physical_connection', label: '物理接続', sortable: true },
        { key: 'actual_frequency', label: '実通信頻度', sortable: true },
        { key: 'protocol', label: '通信種別', sortable: true },
        { key: 'record_size', label: '属性/プロパティサイズ', sortable: true },
        { key: 'network_local', label: 'ネットワーク/ローカル', sortable: true }
      ],
      commandItems: [],
      byProtocolCurrentPage: 1,
      byProtocolPerPage: 100,
      byProtocolFields: [
        { key: 'no', label: 'No.', sortable: true, sortDirection: 'ASC' },
        { key: 'function_class', label: 'システム機能分類', sortable: true },
        { key: 'record_name', label: '属性/プロパティ名称', sortable: true },
        { key: 'communication_trigger', label: '通信トリガ', sortable: true },
        { key: 'frame_type', label: 'フレーム種別', sortable: true },
        { key: 'design_sender', label: '設計用送信元', sortable: true },
        { key: 'design_destination', label: '設計用送信先', sortable: true },
        { key: 'sa', label: 'SA', sortable: true },
        { key: 'da', label: 'DA', sortable: true },
        { key: 'sr', label: 'SR', sortable: true },
        { key: 'dr', label: 'DR', sortable: true },
        { key: 'common_sender', label: '共通送信元', sortable: true },
        { key: 'common_destination', label: '共通送信先', sortable: true },
        { key: 'actual_frequency', label: '実通信頻度', sortable: true },
        { key: 'protocol', label: '通信種別', sortable: true },
        { key: 'record_size', label: '属性/プロパティサイズ', sortable: true },
        { key: 'network_local', label: 'ネットワーク/ローカル', sortable: true }
      ],
      byProtocolItems: [],
      byProtocolFilterOptions: [
        { value: 'protocol', text: '通信種別' },
        { value: 'sa', text: 'SA' },
        { value: 'da', text: 'DA' },
        { value: 'record_name', text: '属性/プロパティ名称' }
      ],
      byProtocolFilterItem: '',
      byProtocolFilterString: '',
      bySenderFields: [
        { key: 'no', label: 'No.', sortable: true, sortDirection: 'ASC' },
        { key: 'function_class', label: 'システム機能分類', sortable: true },
        { key: 'record_name', label: '属性/プロパティ名称', sortable: true },
        { key: 'communication_trigger', label: '通信トリガ', sortable: true },
        { key: 'frame_type', label: 'フレーム種別', sortable: true },
        { key: 'design_sender', label: '設計用送信元', sortable: true },
        { key: 'design_destination', label: '設計用送信先', sortable: true },
        { key: 'sa', label: 'SA', sortable: true },
        { key: 'da', label: 'DA', sortable: true },
        { key: 'common_sender', label: '共通送信元', sortable: true },
        { key: 'common_destination', label: '共通送信先', sortable: true },
        { key: 'integration_sender', label: '統合送信元', sortable: true },
        { key: 'integration_destination', label: '統合送信先', sortable: true },
        { key: 'actual_frequency', label: '実通信頻度', sortable: true },
        { key: 'record_size', label: '属性/プロパティサイズ', sortable: true },
        { key: 'network_local', label: 'ネットワーク/ローカル', sortable: true }
      ],
      bySenderCurrentPage: 1,
      bySenderPerPage: 100,
      bySenderItems: [],
      bySenderFilterOptions: [
        { value: 'integration_sender', text: '統合送信元' },
        { value: 'integration_destination', text: '統合送信先' },
        { value: 'sa', text: 'SA' },
        { value: 'da', text: 'DA' }
      ],
      bySenderFilterItem: '',
      bySenderFilterString: ''
    }
  },
  computed: {
    commandTotalRows () {
      return this.commandItems.length
    },
    byProtocolTotalRows () {
      return this.byProtocolItems.length
    },
    bySenderTotalRows () {
      return this.bySenderItems.length
    },
    byProtocolFilterRegexp () {
      if (this.byProtocolFilterItem === 'protocol' && this.byProtocolFilterString !== '') {
        const pattern = '^' + this.byProtocolFilterString + '$'
        return new RegExp(pattern)
      } else {
        return this.byProtocolFilterString
      }
    },
    ...mapState(['version'])
  },
  methods: {
    async downloadCSV (fields, target, fileName) {
      let csv = '\ufeff' + fields.map(function (elm) { return elm.label }).join(',') + '\n'
      target.forEach(function (elm, no) {
        fields.forEach(function (head, index) {
          if (head.key === 'no') {
            csv += no + 1
          } else {
            if (elm[head.key] === null) {
              csv += ''
            } else {
              csv += elm[head.key]
            }
          }
          if (fields.length - 1 === index) {
            csv += '\n'
          } else {
            csv += ','
          }
        })
      })
      let blob = new Blob([csv],
        { type: 'text/csv' })
      let link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = fileName
      link.click()
      this.all_loading = false
    },
    downloadCommandCSV () {
      const fields = this.commandFields
      const target = this.commandItems
      const fileName = 'CommandList.csv'
      this.downloadCSV(fields, target, fileName)
    },
    downloadByProtocolCSV () {
      const fields = this.byProtocolFields
      const target = this.byProtocolItems
      const fileName = 'CommandByProtocolList.csv'
      this.downloadCSV(fields, target, fileName)
    },
    downloadBySenderCSV () {
      const fields = this.bySenderFields
      const target = this.bySenderItems
      const fileName = 'CommandBySenderList.csv'
      this.downloadCSV(fields, target, fileName)
    },
    async displayCommand () {
      try {
        this.getCommand()
      } catch (e) {
        this.$log.debug(e)
        this.makeToast('失敗', 'エラーが発生しました', 'danger')
      }
    },
    async getCommand () {
      let nextToken = null
      do {
        const result = await API.graphql(graphqlOperation(`
          query getLatestCommand{
            getLatestDesign(version: "${this.version}"){
              job_id
              version
              status
              command_design {
                items{
                  function_class
                  record_name
                  communication_trigger
                  frame_type
                  design_sender
                  design_destination
                  sa
                  da
                  sr
                  dr
                  common_sender
                  common_destination
                  integration_sender
                  integration_destination
                  physical_connection
                  actual_frequency
                  protocol
                  record_size
                  network_local
                }
              }
            }
          }
        `))
        this.$log.debug(result)
        if (result.data.getLatestDesign.command_design.items.length === 0) {
          this.makeToast('失敗', '表示するコマンド設計がありません', 'danger')
        } else {
          result.data.getLatestDesign.command_design.items.forEach(function (elm) {
            for (const key in elm) {
              if (elm[key] === true) {
                elm[key] = 'はい'
              }
              if (elm[key] === false) {
                elm[key] = 'いいえ'
              }
              if (elm[key] === 'Network') {
                elm[key] = 'ネットワーク'
              }
              if (elm[key] === 'Local') {
                elm[key] = 'ローカル'
              }
              if (key === 'actual_frequency') {
                if (elm[key] === 1) {
                  elm[key] = '最短'
                } else if (elm[key] === 60) {
                  elm[key] = '1分'
                } else if (elm[key] === 3600) {
                  elm[key] = '1時間'
                } else if (elm[key] === 86400) {
                  elm[key] = '1日'
                } else if (elm[key] === 2592000) {
                  elm[key] = '1ヶ月'
                } else if (elm[key] === 31536000) {
                  elm[key] = '1年'
                } else {
                  elm[key] = 'その他'
                }
              }
            }
          })
          this.commandItems = [...result.data.getLatestDesign.command_design.items]
        }
        nextToken = result.data.getLatestDesign.command_design.nextToken
      } while (nextToken !== null && nextToken !== undefined)
    },
    async displayByProtocol () {
      try {
        this.getByProtocol()
      } catch (e) {
        this.$log.debug(e)
        this.makeToast('失敗', 'エラーが発生しました', 'danger')
      }
    },
    async getByProtocol () {
      let nextToken = null
      do {
        const result = await API.graphql(graphqlOperation(`
          query getLatestCommand{
            getLatestDesign(version: "${this.version}"){
              job_id
              version
              status
              command_by_protocol {
                items{
                  order
                  function_class
                  record_name
                  communication_trigger
                  frame_type
                  design_sender
                  design_destination
                  sa
                  da
                  sr
                  dr
                  common_sender
                  common_destination
                  actual_frequency
                  protocol
                  record_size
                  network_local
                }
              }
            }
          }
        `))
        this.$log.debug(result)
        if (result.data.getLatestDesign.command_by_protocol.items.length === 0) {
          this.makeToast('失敗', '表示するコマンド設計がありません', 'danger')
        } else {
          result.data.getLatestDesign.command_by_protocol.items.forEach(function (elm) {
            for (const key in elm) {
              if (elm[key] === true) {
                elm[key] = 'はい'
              }
              if (elm[key] === false) {
                elm[key] = 'いいえ'
              }
              if (elm[key] === 'Network') {
                elm[key] = 'ネットワーク'
              }
              if (elm[key] === 'Local') {
                elm[key] = 'ローカル'
              }
              if (key === 'actual_frequency') {
                if (elm[key] === 1) {
                  elm[key] = '最短'
                } else if (elm[key] === 60) {
                  elm[key] = '1分'
                } else if (elm[key] === 3600) {
                  elm[key] = '1時間'
                } else if (elm[key] === 86400) {
                  elm[key] = '1日'
                } else if (elm[key] === 2592000) {
                  elm[key] = '1ヶ月'
                } else if (elm[key] === 31536000) {
                  elm[key] = '1年'
                } else {
                  elm[key] = 'その他'
                }
              }
            }
          })
          this.byProtocolItems = [...result.data.getLatestDesign.command_by_protocol.items]
        }
        nextToken = result.data.getLatestDesign.command_by_protocol.nextToken
      } while (nextToken !== null && nextToken !== undefined)
      this.byProtocolItems.sort(function (a, b) {
        if (a.order < b.order) {
          return -1
        } else {
          return 1
        }
      })
    },
    async displayBySender () {
      try {
        this.getBySender()
      } catch (e) {
        this.$log.debug(e)
        this.makeToast('失敗', 'エラーが発生しました', 'danger')
      }
    },
    async getBySender () {
      let nextToken = null
      do {
        const result = await API.graphql(graphqlOperation(`
          query getLatestCommand{
            getLatestDesign(version: "${this.version}"){
              job_id
              version
              status
              command_by_sender {
                items{
                  order
                  function_class
                  record_name
                  communication_trigger
                  frame_type
                  design_sender
                  design_destination
                  sa
                  da
                  common_sender
                  common_destination
                  integration_sender
                  integration_destination
                  actual_frequency
                  record_size
                  network_local
                }
              }
            }
          }
        `))
        this.$log.debug(result)
        if (result.data.getLatestDesign.command_by_sender.items.length === 0) {
          this.makeToast('失敗', '表示するコマンド設計がありません', 'danger')
        } else {
          result.data.getLatestDesign.command_by_sender.items.forEach(function (elm) {
            for (const key in elm) {
              if (elm[key] === true) {
                elm[key] = 'はい'
              }
              if (elm[key] === false) {
                elm[key] = 'いいえ'
              }
              if (elm[key] === 'Network') {
                elm[key] = 'ネットワーク'
              }
              if (elm[key] === 'Local') {
                elm[key] = 'ローカル'
              }
              if (key === 'actual_frequency') {
                if (elm[key] === 1) {
                  elm[key] = '最短'
                } else if (elm[key] === 60) {
                  elm[key] = '1分'
                } else if (elm[key] === 3600) {
                  elm[key] = '1時間'
                } else if (elm[key] === 86400) {
                  elm[key] = '1日'
                } else if (elm[key] === 2592000) {
                  elm[key] = '1ヶ月'
                } else if (elm[key] === 31536000) {
                  elm[key] = '1年'
                } else {
                  elm[key] = 'その他'
                }
              }
            }
          })
          this.bySenderItems = [...result.data.getLatestDesign.command_by_sender.items]
        }
        nextToken = result.data.getLatestDesign.command_by_sender.nextToken
      } while (nextToken !== null && nextToken !== undefined)
      this.bySenderItems.sort(function (a, b) {
        if (a.order < b.order) {
          return -1
        } else {
          return 1
        }
      })
    }
  }
}
</script>
